"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var minus = function (props) {
    var colorPrimary = props.colorPrimary;
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: "M88.763 53H10.5a2.5 2.5 0 110-5h78.263a2.5 2.5 0 110 5", fill: colorPrimary, fillRule: "evenodd" })));
};
exports.default = minus;
//# sourceMappingURL=minus.js.map